import Swiper from 'swiper';
import { Autoplay, Virtual, EffectCreative } from 'swiper/modules';

window.addEventListener('DOMContentLoaded', () => {
    const STEPS_CAROUSEL = document.querySelectorAll('.steps-carousel');
    if (STEPS_CAROUSEL) {
        STEPS_CAROUSEL.forEach(carousel => {
            new Swiper(carousel, {
                slidesPerView: 1.33,
                spaceBetween: 24,
                centeredSlides: true,
                centerInsufficientSlides: true,
                autoplay: {
                    delay: 5000,
                    disableOnInteraction: false,
                },
                speed: 800,
                modules: [Autoplay],
                breakpoints: {
                    640: {
                        slidesPerView: 2.33,
                        spaceBetween: 24,
                        centeredSlides: false,
                        centerInsufficientSlides: true,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 24,
                        centeredSlides: false,
                        centerInsufficientSlides: true,
                    },
                    1400: {
                        slidesPerView: 5,
                        spaceBetween: 32    ,
                        autoplay: false,
                        centeredSlides: false,
                        centerInsufficientSlides: true,
                    }

                },
            });
        });
    }

});